(function () {
	'use strict';

	// loading form
	$('.overlay-box-trigger').on('click', function () {

			var querystring = avm.require('avast.url.unserialize')(),
				serialize = avm.require('avast.url.serialize');

			function GetURLParameter(sParam) {
				var sPageURL = 'qp_sid=SV_cBlKVGooLHFsuH3&source2=AvastWeb';
				var sURLVariables = sPageURL.split('&');
				for (var i = 0; i < sURLVariables.length; i++) {
					var sParameterName = sURLVariables[i].split('=');
					if (sParameterName[0] == sParam) {
						return sParameterName[1];
					}
				}
			}

			var source2 = GetURLParameter('source2');
			querystring.qp_sid = GetURLParameter('qp_sid')

			var survey = {
				init: function () {
					var iframeContainer = document.getElementById('surveryDiv'),
						lang = this.getLangCode(),
						_params = {
							Q_Language: lang ? lang.toUpperCase() : '',
							ext_ref: querystring.p_hid ? querystring.p_hid : this.clientInfoHid(),
							source: 'avast',
							source2: source2
						},
						params = serialize(_params),
						iframe;

					params = params ? '?' + params : '';

						iframe = document.createElement('iframe');
						iframe.setAttribute("id", "myframe"); //We set the id to the iframe
						iframe.setAttribute("height", "1400px"); //We set the id to the iframe
						iframe.src = querystring.qp_sid ? 'https://survey.eu.qualtrics.com/jfe/form/' + querystring.qp_sid + params : '';
						iframeContainer.appendChild(iframe);
				},
				getLangCode: function () {
					return querystring.p_lng || navigator.language || navigator.userLanguage;
				},
				clientInfoHid: function () {
					var client = (window.avastGlobals && window.avastGlobals.client) ? window.avastGlobals.client : null,
						hid = client ? client.p_hid : '';

					return hid;
				}
			};

			survey.init();
	})

})();
